export default (typeIds = [], employeeTypeId = null) => {
  const employees =
    typeIds.length > 0 && employeeTypeId !== null
      ? typeIds.filter(item => item === employeeTypeId)
      : [];
  return employees.length > 0;
};
